import { isAdmin, isProfessor, roles } from "@/services/auth.js"

const initialState = () => {
  return {
    roles: [],
  }
}

export default {
  namespaced: true,

  state: initialState,
  mutations: {
    setRoles(state, roles) {
      state.roles = roles
    },
  },
  actions: {
    setRoles({ commit }, newState) {
      if (!newState) {
        throw `invalid roles given: ${newState}`
      }
      for (const role of newState) {
        if (roles.indexOf(role) === -1) {
          console.error(`invalid Role found: ${role}`)
        }
      }
      commit("setRoles", newState)
    },
  },
  getters: {
    isAdmin(state) {
      return isAdmin(state.roles)
    },
    isProfessor(state) {
      return isProfessor(state.roles)
    },
  },
}
